import React from 'react';
import { GenericEntry } from '../..';
import { User } from '../../../../../entities/User';
import { Application } from '../../../../../entities/Application';
import { Simple } from '../../../../../entities/ApplicationFeed';
import { AuthorName } from '../../AuthorName';
import { AlertObject } from '../../../../../components/Alert';

interface PropTypes {
  application: Application;
  currentUser: User;
  entry: Simple;
  isLastItemInPage: boolean;
  setAlert: (data: AlertObject) => void;
  reloadFeed: () => void;
}

export function BackgroundCheckInitiatedEntry(props: PropTypes) {
  return (
    <GenericEntry
      icon='bi-person-bounding-box'
      iconClassName='bg-pink-light'
      title={
        <>
          <AuthorName name={props.entry.authorName} /> sent a background check
          to <strong>{props.application.candidate.name}.</strong>
        </>
      }
      date={props.entry.createdAt}
      {...props}
    />
  );
}
